import { put, takeEvery } from "redux-saga/effects";
import { PICTREE } from "../../constants";
import {
  setPicTreeRegularSeasonPageData,
  setPicTreeRegularSeasonPageLoading,
} from "actions";

const buildMockRegularSeasonViewModel = () => ({
  selectedSeasonId: "regular-season-1",
  selectedCompanyCode: "NTT_ME",
  seasonOptions: [
    { value: "regular-season-1", label: "レギュラーシーズン1" },
    { value: "regular-season-2", label: "レギュラーシーズン2" },
    { value: "regular-season-3", label: "レギュラーシーズン3" },
    { value: "regular-season-4", label: "レギュラーシーズン4" },
  ],
  companyOptions: [
    { value: "NTT_ME", label: "NTT ME", active: true },
    { value: "TEPCO", label: "東京電力 TEPCO", active: false },
    { value: "NTT_FT", label: "NTT FT", active: false },
  ],
  kpis: [
    {
      key: "uniqueShot",
      title: "ユニーク撮影本数",
      value: "2,080,557",
      subtitle: "RS1〜5通算",
    },
    {
      key: "achievementRate",
      title: "撮影達成率",
      value: "74.2%",
      subtitle: "対象 2,800,000本",
      highlight: "NTT-ME 初期想定",
    },
    {
      key: "reviewOk",
      title: "レビューOK基数",
      value: "1,842,301",
      subtitle: "OK率 88.5%",
    },
    {
      key: "uniqueShooter",
      title: "ユニーク撮影者数",
      value: "8,342",
      subtitle: "累計参加者",
    },
    {
      key: "firstShooter",
      title: "初回撮影者数",
      value: "1,203",
      subtitle: "今期新規",
    },
  ],
  trend: {
    date: ["4/11", "4/16", "4/21", "4/26", "5/1", "5/6", "5/11", "5/16", "5/21"],
    uniqueShots: [24100, 25500, 20400, 19800, 19400, 31600, 27200, 31400, 21800],
    reviewerOk: [350, 410, 230, 260, 180, 330, 290, 360, 175],
    uniqueShooters: [198, 214, 171, 168, 142, 202, 196, 225, 154],
  },
  seasonChart: {
    labels: ["RS1"],
    series: [
      { name: "NTT ME", data: [420] },
    ],
  },
  companyRows: [
    {
      companyCode: "NTT_ME",
      companyName: "NTT ME",
      rate: 78.3,
      status: "良好",
      progress: 78.3,
      period: "RS1〜5",
    },
  ],
});

export function* handleRegularSeasonPageData(action) {
  try {
    yield put(setPicTreeRegularSeasonPageLoading(true));
    const viewModel = buildMockRegularSeasonViewModel();
    if (action && action.payload && action.payload.selectedSeasonId) {
      viewModel.selectedSeasonId = action.payload.selectedSeasonId;
    }
    yield put(setPicTreeRegularSeasonPageData(viewModel));
  } catch (error) {
    console.log(error);
  } finally {
    yield put(setPicTreeRegularSeasonPageLoading(false));
  }
}

export default function* pictreeRegularSeasonSaga() {
  yield takeEvery(PICTREE.GET_REGULAR_SEASON_PAGE_DATA, handleRegularSeasonPageData);
}
